import {
  countries
} from '../helpers/countries';
import {
  applicantFields,
  studentNumberFields,
  provinceOfResidenceFields
} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'lloydsascnallincl';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [{
      key_path: ['application', 'additional_data', 'membership_number'],
      as: 'Association Membership Number',
      is_static_by_default: true
    }],
    dependent_fields: [
      ...applicantFields('*', [{
          value: 'dependent',
          text: 'Dependent Child'
        },
        {
          value: 'travelling companion',
          text: 'Travelling Companion'
        },
        {
          value: 'spouse',
          text: 'Spouse'
        }
      ]),
      ...studentNumberFields('*')
    ],
    coverage_fields: [{
        key_path: ['application', 'additional_data', 'policy_type'],
        as: 'Policy Type',
        type: 'radio',
        options: [{
            value: 'single trip',
            text: 'Single Trip'
          },
          {
            value: 'multi-trip annual',
            text: 'Multi-Trip Annual'
          }
        ],
        is_static_by_default: true
      },
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Country of Origin',
        type: 'dropdown',
        options: countries(),
        is_static_by_default: true
      },
      ...provinceOfResidenceFields(),
      {
        show_if: [{
          key_path: ['application', 'additional_data', 'policy_type'],
          value: 'single trip'
        }],
        key_path: ['application', 'additional_data', 'trip_cost'],
        as: 'Trip Cost',
        format: 'currency'
      },
      {
        key_path: ['application', 'additional_data', 'cancel_delux'],
        as: 'Trip Cancellation - Deluxe Option',
        type: 'dropdown',
        options: [
          {value: 'no', text: 'No'},
          {value: 'yes', text: 'Yes'}
        ]
      },
      {
        show_if: [{
          key_path: ['application', 'additional_data', 'policy_type'],
          value: 'multi-trip annual'
        }],
        key_path: ['application', 'additional_data', 'trip_cancellation_coverage_limit'],
        as: 'Trip Cancellation Coverage Limit',
        type: 'dropdown',
        options: [{
          value: 2500,
          text: '$2,500 per trip, per person'
        }, ],
        is_static_by_default: true
      },
      {
        key_path: ['application', 'additional_data', 'trip_booked_date'],
        as: 'Date the Trip was Booked',
        format: 'date'
      },
      {
        show_if: [{
          key_path: ['application', 'additional_data', 'policy_type'],
          value: 'single trip'
        },
        {
          key_path: ['application', 'additional_data', 'country_of_origin'],
          value: 'CA'
        }],
        key_path: ['application', 'additional_data', 'destination'],
        as: 'Destination',
        type: 'dropdown',
        options: countries()
      },
      {
        show_if: [{
          key_path: ['application', 'additional_data', 'policy_type'],
          value: 'single trip'
        }],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'country_of_origin'],
          value: 'CA'
        }],
        key_path: ['application', 'additional_data', 'destination'],
        as: 'Destination',
        type: 'dropdown',
        options: countries(),
        is_static_by_default: true
      },
      {
        show_if: [{
          key_path: ['application', 'additional_data', 'policy_type'],
          value: 'multi-trip annual'
        }],
        key_path: ['application', 'additional_data', 'destination'],
        as: 'Destination',
        type: 'dropdown',
        options: [{
          value: 'WW',
          text: 'Worldwide'
        }],
        is_static_by_default: true
      },
      {
        show_if: [{
          key_path: ['application', 'additional_data', 'policy_type'],
          value: 'multi-trip annual'
        }],
        key_path: ['application', 'additional_data', 'number_of_days_per_trip'],
        as: 'Number of Days per Trip',
        type: 'dropdown',
        options: [{
          value: 30,
          text: '30 Days'
        }, ],
        is_static_by_default: true
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/clients/lloydsascnallincl.js